/* eslint-disable @typescript-eslint/naming-convention */
import { z } from 'zod'

import { phoneNumber } from '~/lib'

import type { ContactInquiryType as ContactInquiryTypeOrigin } from '@prisma/client'

// NOTE: 直接enumをprismaからimportして使うと@prisma/client起因のエラーになるのでこうする。
// ref. https://github.com/prisma/prisma/issues/12504#issuecomment-1147356141
export const ContactInquiryType: { [k in ContactInquiryTypeOrigin]: k } = {
  SERVICE_INQUIRY: 'SERVICE_INQUIRY',
  SITE_VISIT_REQUEST: 'SITE_VISIT_REQUEST',
  AVAILABILITY_CHECK: 'AVAILABILITY_CHECK',
  OTHER: 'OTHER',
} as const satisfies Record<string, ContactInquiryTypeOrigin>

export const contactFormSchema = z.object({
  contactInquiryType: z
    .array(z.nativeEnum(ContactInquiryType))
    .min(1, '1つ以上選択してください'),
  name: z.string().max(60),
  organization: z.string().max(50),
  email: z.string().max(254).email(),
  phone: phoneNumber(z.string()),
  content: z.string().max(2000).optional(),
  agree: z.boolean({
    errorMap: () => ({
      message: '利用規約・プライバシーポリシーに同意してください',
    }),
  }),
})

export type ContactFormType = z.infer<typeof contactFormSchema>
